import React from 'react';
import Services from '../components/Services/Services';

const ServicesPage: React.FC = () => {
  return <Services />;
};

export default ServicesPage;
